import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListingSizeComponentDef } from '@df/catalog-ui/listing/size/listing-size.component.def';
@Component({
    selector: 'listing-size',
    templateUrl: './listing-size.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass]
})
export class ListingSizeComponent extends ListingSizeComponentDef {
}
